export class GeneralPhotoRemarksDto {
  photoId: string;
  remarks: string;

  constructor(photoId: string, remarks: string) {
    this.photoId = photoId;
    this.remarks = remarks;
  }
}
